import styles from "./ExternalAnchorLink.module.css";

export const ExternalAnchorLink = (
  props: React.AnchorHTMLAttributes<HTMLAnchorElement>,
) => {
  return (
    <a
      {...props}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.link}
    />
  );
};
